import { jsx as h, jsxs as l } from "react/jsx-runtime";
function e(a) {
  return /* @__PURE__ */ h("svg", { height: "16px", viewBox: "4 4 16 16", width: "16px", ...a, children: /* @__PURE__ */ l("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ h("path", { d: "M4 4h16v16H4z" }),
    /* @__PURE__ */ h(
      "path",
      {
        d: "M17.744 6.23h-1.231v-.82a.41.41 0 00-.41-.41H7.897a.41.41 0 00-.41.41v.82h-1.23a2.258 2.258 0 00-.001 4.515.41.41 0 100-.82 1.436 1.436 0 010-2.873h1.231v3.487c0 2.018 1.34 3.79 3.282 4.341v1.403h-.947a.41.41 0 00-.347.193l-.9 1.436a.406.406 0 000 .41c.068.13.201.213.348.217h6.154a.409.409 0 00.359-.615l-.9-1.436a.411.411 0 00-.358-.205h-.947V14.88a4.514 4.514 0 003.282-4.34V7.05h1.23a1.435 1.435 0 11.001 2.872.41.41 0 100 .82 2.256 2.256 0 100-4.51zm-3.408 11.488H9.664l.385-.615h3.898l.39.615zm-1.926-1.436h-.82v-1.25c.135 0 .273.02.41.02.137 0 .275 0 .41-.02v1.25zm3.282-5.744a3.692 3.692 0 11-7.384 0V5.821h7.384v4.717z",
        fill: "#0b4721"
      }
    )
  ] }) });
}
export {
  e as default
};
